import { forwardRef, type InputHTMLAttributes } from 'react'

import { Input } from '../primitives/input'

/** `HH:MM` (24-hour) — the backend's TIME wire format. Uses the native time input; `step` in minutes. */
export const TimeField = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & { readonly stepMinutes?: number }
>(function TimeField({ stepMinutes = 5, ...props }, ref) {
  return <Input ref={ref} type="time" step={stepMinutes * 60} {...props} />
})
